app.controller('ActivationCtrl', ['$scope', '$routeParams', '$http', '$window', '$q', 'appFactory',
    function ($scope, $routeParams, $http, $window, $q, appFactory) {

    $scope.user = {};

    if ($routeParams.generatedkey) {
        $scope.user.generatedkey = $routeParams.generatedkey;
    }

    $scope.page = 'activation';

    var allPromise = $q.all([

        appFactory.getData(`service/client.svc/recheckActivationLink?key=${$routeParams.generatedkey}`).then(function (data) {

            if (data.status == 200) {

                if (!data.data.d.result) {
                    $window.location.href = "#/login";
                    $window.location.reload();
                } else {

                    $window.location.href = "#/login";

                    var SWALtranslate = $scope.SWALtranslate('activationsuccess');
                    Swal.fire(SWALtranslate.title, SWALtranslate.message, 'success');
                }
            }
        })
    ]);

    allPromise.then(function () {

    });
}]);
